import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_XMAS_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_XMAS_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_XMAS_80,
  },
  {
    pageId: PageId.UPSELL_XMAS_80,
  },
  {
    pageId: PageId.DOWNLOAD_XMAS_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
